import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { CurrentMentorsActions } from "../actions/currentClientActions";
import { ObserverState } from "../../../Shared/sharedTypes";

export default function activeObserversReducer(state = initialState.activeObservers, action: CurrentMentorsActions): ObserverState {
    switch (action.type) {
        case types.SESSION_HAS_OBSERVER_COMPLETE: {
            const originalObservers = state?.registrations.map(r => r.deviceId);
            const newObservers = action.activeObservers.map(r => r.deviceId);

            return { 
                registrations: action.activeObservers,
                newObserverPresent: !arrayEquals(originalObservers, newObservers)
            };
        }
        default:
            return state;
    }
}

const arrayEquals = (a: any[], b: any[]) => {
    return Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((val, index) => val === b[index]);
}
